export var is401Error = function (error) {
    if (error === void 0) { error = {}; }
    if (error.status === 401) {
        return true;
    }
    return false;
};
export var is406Error = function (error) {
    if (error === void 0) { error = {}; }
    if (error.status === 406) {
        return true;
    }
    return false;
};
export var is403Error = function (error) {
    if (error === void 0) { error = {}; }
    var _a;
    if (((_a = error) === null || _a === void 0 ? void 0 : _a.status) === 403) {
        return true;
    }
    return false;
};
